import styled from 'styled-components'
import DefaultButtonText from 'components/button/ButtonText'

const ButtonText = styled(DefaultButtonText)`
  font-family: inherit;
`

export default ButtonText
